import getLang from 'LearningCenterUI/utils/getLang';
import { useEffect } from 'react';
import { SCREENS } from '../../../constants/Tracking';
import UsageTracker from '../../../utils/UsageTracker';
import useRedirectProgressedTrack from '../hooks/useRedirectProgressedTrack';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthenticatedCourseBrochure = ({
  match: {
    params: {
      trackId
    }
  }
}) => {
  const language = getLang();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.AUTHENTICATED_COURSE_BROCHURE,
      trackId,
      language
    });
  }, [language, trackId]);
  const {
    redirectLoading,
    redirectError
  } = useRedirectProgressedTrack(Number(trackId), language);
  if (redirectLoading) {
    return /*#__PURE__*/_jsx("p", {
      children: "Loading..."
    });
  }
  if (redirectError) {
    return /*#__PURE__*/_jsx("p", {
      children: "Error!"
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: "Course brochure page!"
  });
};
export default AuthenticatedCourseBrochure;